import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

@Component({
  selector: 'gs-footer',
  templateUrl: './GSFooter.html',
  styleUrls: ['./GSFooter.scss'],
})
export class GSFooterComponent extends AbstractComponent {
  public scope = {
    appVersion: '1.0.0',
  };

  public constructor() {
    super();
  }

  public render() {
    this.scope.appVersion = '1.0.0';
  }
}
